import AlbumSlideshowGridViewer from './AlbumSlideshowGridViewer';

export default AlbumSlideshowGridViewer;
